// extracted by mini-css-extract-plugin
module.exports = {"seatsLegend__wrapper":"seatsLegend__wrapper-3grS5"};